import Joi from 'joi';
import type { EndConversationReasons } from '../dialogue';
import { endConversationReasonsSchema } from '../dialogue';
import { objectSchemaOf } from '../helpers';

export type RingBellReason =
  | 'error'
  | 'timeout'
  | 'manual'
  | 'offline'
  | EndConversationReasons;

export const ringBellReasonSchema = Joi.string()
  .valid('error', 'timeout', 'manual', 'offline')
  .concat(endConversationReasonsSchema)
  .required();

export type RingBellFrom = 'console' | 'hil';

export const ringBellFromSchema = Joi.string()
  .valid('hil', 'console')
  .required();

export interface IRingBellParams {
  conversationId: string;
  reason: RingBellReason;
  from: RingBellFrom;
  description?: string;
  endConversation?: boolean;
}

export const ringBellParamsSchema = objectSchemaOf<IRingBellParams>({
  conversationId: Joi.string().required(),
  from: ringBellFromSchema,
  reason: ringBellReasonSchema,
  description: Joi.string(),
  endConversation: Joi.bool(),
});

export interface ISendMessageParams {
  messageBody: string;
  conversationId: string;
  staffId?: string;
  allowResponse?: boolean;
}

export const sendMessageParamsSchema = objectSchemaOf<ISendMessageParams>({
  messageBody: Joi.string().required(),
  conversationId: Joi.string().required(),
  staffId: Joi.string(),
  allowResponse: Joi.boolean().optional(),
});

export interface ITriggersApi {
  triggersRingBell(params: IRingBellParams): Promise<void>;
  triggersSendMessage(params: ISendMessageParams): Promise<void>;
}
